import { render, staticRenderFns } from "./PrintableOffer.vue?vue&type=template&id=12b2f8a2"
import script from "./PrintableOffer.vue?vue&type=script&lang=js"
export * from "./PrintableOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports